import * as React from "react";
import { useMemo } from "react";
import { useFormikContext, Field } from "formik";
import { FormikSelect, FormikInput, FormikInputList } from "security-app/components/common/FormikComponents";
import { useGetCategories, useGetPriorities } from "security-app/hooks/useAssetsAPI";
import usePermissions from "hooks/usePermissions";
import { Row } from "common/components";
function Step1() {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
  const { values, touched, errors } = useFormikContext();
  const { isPermitted } = usePermissions();
  const isFromSource = useMemo(() => !!(values == null ? void 0 : values.imported_from), [values]);
  const canEdit = isPermitted("asset:edit");
  const { categories } = useGetCategories();
  const categoryOptions = useMemo(
    () => categories.map((category) => ({
      value: category.category,
      label: category.category
    })),
    [categories]
  );
  const { priorities } = useGetPriorities();
  const priorityOptions = useMemo(
    () => [...priorities].sort((a, b) => b.priority - a.priority).map((priority) => ({
      value: priority.priority,
      label: priority.text
    })),
    [priorities]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikInput,
      name: "name",
      id: "name",
      type: "text",
      label: "Asset Name *",
      placeholder: "Enter machine name",
      value: values.name,
      required: true,
      error: touched.name && errors.name ? errors.name : void 0,
      bsStyle: touched.name && errors.name ? "error" : null,
      disabled: !canEdit || isFromSource
    }
  ), /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikInput,
      name: "details.owner",
      id: "owner",
      type: "text",
      label: "Owner",
      placeholder: "Enter asset owner",
      value: (_a = values.details) == null ? void 0 : _a.owner,
      disabled: !canEdit
    }
  )), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikInputList,
      label: "IP Addresses",
      name: "details.ip_addresses",
      id: "ip_addresses",
      placeholder: "Enter all the IPs to map this asset to logs",
      isClearable: true,
      help: "Press Tab or Enter to accept the entered value",
      values: (_b = values.details) == null ? void 0 : _b.ip_addresses,
      error: ((_c = touched.details) == null ? void 0 : _c.ip_addresses) && ((_d = errors.details) == null ? void 0 : _d.ip_addresses) ? (_e = errors.details) == null ? void 0 : _e.ip_addresses : "",
      bsStyle: ((_f = touched.details) == null ? void 0 : _f.ip_addresses) && ((_g = errors.details) == null ? void 0 : _g.ip_addresses) ? "error" : null,
      isDisabled: !canEdit
    }
  )), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikInputList,
      label: "Hostnames",
      name: "details.hostnames",
      id: "hostnames",
      placeholder: "Enter all the Hostnames to map this asset to logs",
      isClearable: true,
      help: "Press Tab or Enter to accept the entered value",
      values: (_h = values.details) == null ? void 0 : _h.hostnames,
      error: ((_i = touched.details) == null ? void 0 : _i.hostnames) && ((_j = errors.details) == null ? void 0 : _j.hostnames) ? (_k = errors.details) == null ? void 0 : _k.hostnames : "",
      bsStyle: ((_l = touched.details) == null ? void 0 : _l.hostnames) && ((_m = errors.details) == null ? void 0 : _m.hostnames) ? "error" : null,
      isDisabled: !canEdit
    }
  )), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikInputList,
      label: "MACs",
      name: "details.mac_addresses",
      id: "mac_addresses",
      placeholder: "Enter all the MACs to map this asset to logs",
      isClearable: true,
      help: "Press Tab or Enter to accept the entered value",
      values: (_n = values.details) == null ? void 0 : _n.mac_addresses,
      error: ((_o = touched.details) == null ? void 0 : _o.mac_addresses) && ((_p = errors.details) == null ? void 0 : _p.mac_addresses) ? (_q = errors.details) == null ? void 0 : _q.mac_addresses : "",
      bsStyle: ((_r = touched.details) == null ? void 0 : _r.mac_addresses) && ((_s = errors.details) == null ? void 0 : _s.mac_addresses) ? "error" : null,
      isDisabled: !canEdit
    }
  )), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikSelect,
      name: "category",
      id: "category",
      placeholder: "Add or select a category",
      multi: true,
      allowCreate: true,
      label: "Categories",
      value: values.category,
      options: categoryOptions,
      maxMenuHeight: 200,
      menuPlacement: "top",
      disabled: !canEdit
    }
  ), /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikSelect,
      name: "priority",
      id: "priority",
      placeholder: "Select a priority",
      label: "Priority",
      value: values.priority,
      options: priorityOptions,
      maxMenuHeight: 200,
      menuPlacement: "top",
      disabled: !canEdit,
      clearable: false
    }
  )), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikInput,
      name: "details.description",
      id: "description",
      type: "textarea",
      label: "Description",
      rows: 4,
      placeholder: "Enter asset description",
      value: (_t = values.details) == null ? void 0 : _t.description,
      disabled: !canEdit
    }
  )));
}
export default Step1;
